
// @ts-nocheck

import { FaAngleUp } from 'react-icons/fa';
import { h, Fragment } from "preact";
import { useContext, useEffect, useRef, useState } from "preact/hooks";
import { Header } from "./header";
import { Form } from "./form";
import { Content } from "./content";
import { CalculatorProvider, useCalculatorContext } from "./context";
import { ServiceType } from "./types";
import { useForm } from "react-hook-form";
import { actions } from "./reducer";
import { sortVendorsByAlphabet } from "../../utils";
import { sendMailJSON } from "../../tools";
import { errorMessagePopup, successMessagePopup } from "../../popups";
import CalcTypeContext from "./commonContext";
import ReCAPTCHA from "react-google-recaptcha";
export interface IFormInputs {
  name: string;
  phone: string;
}

function CalculatorInner({ type }: { type: string }) {
  const [hidden, setHidden] = useState<Boolean>(false);
  const recaptchaRef = useRef();
  const {
    state: {
      serviceKits,
      currentKitIndex,
      currentVendorIndex,
      productsSum,
      optionsSum,
      currentProducts,
      serviceOptions,
      currentVendor,
      setupSum,
    },
    dispatch,
  } = useCalculatorContext();

  let onSubmit = async (data) => {
    let currentKit = serviceKits[currentKitIndex];

    if (!recaptchaRef.current) {
      errorMessagePopup("Капча не загружена");
      return;
    }
    // @ts-ignore
    const token = await recaptchaRef.current.executeAsync();
    if (!token) {
      errorMessagePopup("Капча не загружена или не верна");
      return;
    }

    let response = await sendMailJSON({
      credentials: data,
      productsSum: productsSum,
      optionsSum: optionsSum,
      setupSum: setupSum,
      currentVendor: currentVendor,
      currentKit: {
        name: currentKit.name,
        subscription_min: currentKit.subscription_min,
      },
      type: type,
      currentProducts,
      serviceOptions,
      widget: "calculator",
      token: token
    });

    if (response.ok) {
      successMessagePopup();
    } else {
      errorMessagePopup();
    }
  };

  useEffect(() => {
    dispatch(actions.setCurrentOptions(serviceKits[0].options));
    dispatch(actions.setCurrentProducts(serviceKits[0].vendors[0].products));
  }, [type]);

  useEffect(() => {
    dispatch(
      actions.setProductsSum(
        sortVendorsByAlphabet(serviceKits[currentKitIndex].vendors)[
          currentVendorIndex
        ].base_cost
      )
    );

    dispatch(
      actions.setVendors(
        sortVendorsByAlphabet(serviceKits[currentKitIndex].vendors)
      )
    );

    dispatch(actions.setSetupSum());
  }, [currentVendorIndex, currentKitIndex, type]);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<IFormInputs>();

  console.log("Calculator/index.tsx");
  return (
    <div
      className="single-serviceConsole__kits kit-calculator"
      style={{
        background:
          "/local/templates/Leggis/assets/images/white-paper.png) 50% 50% no-repeat; background-size:cover",
        }}
    >
      <div className="g-wrapper">
        <div class="calc-title-00">
          Стоимость тревожной кнопки
        </div>
        <div className="single-serviceConsole__kits__wrapper">
          <Header
            vendors={serviceKits[currentKitIndex].vendors}
            currentKitIndex={currentKitIndex}
            currentVendorIndex={currentVendorIndex}
            serviceKits={serviceKits}
          />
          <div className="single-serviceConsole__kits__wrapper-form reveal">
            <div className="single-serviceConsole__kits__wrapper-form-block-header">
              <div className="header-title">Оборудование и опции</div>

              <div
                className={
                  "single-serviceConsole__kits__wrapper-form-block-header-button " +
                  (!hidden
                    ? ""
                    : "single-serviceConsole__kits__wrapper-form-block-header-button-active")
                }
                onClick={() => setHidden(!hidden)}
              >
                <div className="single-serviceConsole__kits__wrapper-form-block-header-button-container ">
                  <span>{hidden ? "Показать" : "Скрыть"}</span>
                </div>
                <FaAngleUp/>
              </div>
            </div>
          </div>
          {!hidden && (
            <div class="single-serviceConsole__kits__wrapper-form-block-body">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <div class="single-serviceConsole__kits__wrapper-form-block-body-left">
                      <div class="single-serviceConsole__kits__wrapper-form-block-body-left-block">
                        <Content />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Form
                register={register}
                handleSubmit={handleSubmit(onSubmit)}
                productsSum={productsSum}
                optionsSum={optionsSum}
                setupSum={setupSum}
              />
              <ReCAPTCHA 
                // @ts-ignore
                ref={recaptchaRef as any}
                size="invisible"
                sitekey="6LconrceAAAAANL0ht2OfJ6m-mqvPzZJoWdmWVup"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function Calculator({ type }: ServiceType) {
  if (type === "common") {
    return <CommonCalculator />;
  }

  return (
    <CalculatorProvider serviceType={type}>
      <CalculatorInner type={type} />
    </CalculatorProvider>
  );
}

function CommonCalculator() {
  let [commonType, setCommonType] = useState<"flat" | "house" | "business">(
    "flat"
  );

  return (
    <CalcTypeContext.Provider
      value={{ setType: setCommonType, type: commonType, isCommon: true }}
    >
      <Calclol />
    </CalcTypeContext.Provider>
  );
}


function Calclol() {
  let context = useContext(CalcTypeContext)

  console.log("Calclol")
  console.log(context)
  return (<CalculatorProvider serviceType={context.type}>
    <CalculatorInner type={context.type} />
  </CalculatorProvider>)
}